const getDataFieldsstackedimage = () => {
    return [
        {
            title: "X-Axis",
            type: "dropzone",
            single: true,
            dataTypeAllowed: "all",
            reduxKey: "groupByFields",
            itemInArray: true,
        },

        {
            title: "Y-Axis",
            type: "dropzone",
            single: true,
            dataTypeAllowed: "all",
            reduxKey: "valueColumns",
            itemInArray: true,
        },
        {
            title: "Stack",
            type: "dropzone",
            single: true,
            dataTypeAllowed: "all",
            reduxKey: "rows",
            itemInArray: true,
        },
        {
            title: "Filters",
            type: "dropzone",
            single: false,
            dataTypeAllowed: "all",
            reduxKey: "filters",
            itemInArray: true,
        },
        {
            title: "Tooltip",
            type: "dropzone",
            single: false,
            dataTypeAllowed: "all",
            reduxKey: "tooltip",
            itemInArray: true,
        },
        {
            title: "Row Limit",
            type: "dropdown",
            reduxKey: "rowLimit",
            itemInArray: false,
            defaultValue: 500,
            valueType: "Number",
            canEdit: true,
        },
    ];
};

const getCustomizationFieldStackedimage = () => {
    return [
        {
            title: "Color",
            type: "COLOR",
            reduxKey: "colorSchemeid",
            defaultType: "RANDOM",
        },

        //icon custom
        {
            title: "Icon",
            type: "ICON",
            reduxKey: "icon",
            defaultType: "default",
            innerComponents: [
                //visiable  icon bar and X axis
                {
                    title: "TickIcon",
                    type: "checkbox",
                    defaultValue: false,
                    reduxKey: "isbarXasixIconVisible",
                },

                {
                    title: "Icon Alignment",
                    type: "SELECT_BOX",
                    reduxKey: "imageAlignment",
                    options: [
                        { label: "Contain", value: "contain" },
                        { label: "Cover", value: "cover" },
                        { label: "None", value: "cone" },
                    ],
                    defaultValue: { label: "Cover", value: "cover" },
                    isParent: true,
                    parentType: "CONTAINER_WITH_TOGGLE",
                },

                {
                    title: "Icon Width",
                    type: "range",
                    reduxKey: "imageWidth",
                    defaultValue: 70,
                    minValue: 0,
                    maxValue: 100,
                    isParent: true,
                    parentType: "CONTAINER_WITH_TOGGLE",
                },
                {
                    title: "Icon Height",
                    type: "range",
                    reduxKey: "imageHeight",
                    defaultValue: 70,
                    minValue: 0,
                    maxValue: 100,
                    isParent: true,
                    parentType: "CONTAINER_WITH_TOGGLE",
                },
                //rotate icon
                {
                    title: "RotateIcon",
                    type: "range",
                    defaultValue: 0,
                    minValue: 0,
                    maxValue: 360,
                    reduxKey: "iconRotate",
                    parentType: "CONTAINER_WITH_TOGGLE",
                    isParent: true,
                },
            ],
        },

        {
            title: "Bar Size",
            type: "range",
            defaultValue: "45",
            minValue: 0,
            maxValue: 50,
            reduxKey: "barSize",
            itemInArray: false,
        },
        //iconcustom

        //label
        {
            title: "Label",
            type: "CONTAINER_WITH_TOGGLE",
            defaultValue: false,
            reduxKey: "isLabelVisible",
            innerComponents: [
                {
                    title: "Position",
                    type: "SELECT_BOX",
                    reduxKey: "labelPosition",
                    options: [
                        { label: "Top", value: "top" },
                        { label: "Bottom", value: "bottom" },
                        { label: "Center", value: "center" },
                    ],
                    defaultValue: { label: "Center", value: "center" },
                    isParent: true,
                },

                {
                    title: "Font Color",
                    type: "fontColor",
                    reduxKey: "labelFontColor",
                    parentType: "CONTAINER_WITH_TOGGLE",
                    isParent: true,
                },
                {
                    title: "Font Size",
                    type: "range",
                    defaultValue: 9,
                    minValue: 10,
                    maxValue: 40,
                    reduxKey: "labelFontSize",
                    parentType: "CONTAINER_WITH_TOGGLE",
                    isParent: true,
                },

                {
                    title: "Rotate",
                    type: "range",
                    defaultValue: 0,
                    minValue: 0,
                    maxValue: 360,
                    reduxKey: "labelRotate",
                    parentType: "CONTAINER_WITH_TOGGLE",
                    isParent: true,
                },
            ],
        },

        {
            title: "StackedBar",
            type: "checkbox",
            defaultValue: true,
            reduxKey: "isStackbarVisible",
        },
        //transpose

        {
            title: "TransPose",
            type: "checkbox",
            defaultValue: false,
            reduxKey: "isTransposeVisible",
        },

        {
            title: "Grid",
            type: "checkbox",
            defaultValue: false,
            reduxKey: "isGridVisible",
        },
        //AXES label
        {
            title: "Axes label",
            type: "CONTAINER_WITH_TOGGLE",
            defaultValue: false,
            reduxKey: "isAxeslabelVisible",
            innerComponents: [
                {
                    title: "Font Size",
                    type: "range",
                    defaultValue: 21,
                    minValue: 20,
                    maxValue: 40,
                    reduxKey: "labelFontSize",
                    parentType: "CONTAINER_WITH_TOGGLE",
                    isParent: true,
                },
                {
                    title: "Font Color",
                    type: "fontColor",
                    reduxKey: "labelFontColor",

                    defaultValue: "#878787",
                    parentType: "CONTAINER_WITH_TOGGLE",
                    isParent: true,
                },
            ],
        },
        //legend
        {
            title: "Legend",
            type: "CONTAINER_WITH_TOGGLE",
            defaultValue: false,
            reduxKey: "isLegendVisible",
            innerComponents: [
                {
                    title: "Align",
                    type: "SELECT_BOX",
                    reduxKey: "legendAlign",
                    options: [
                        { label: "Left", value: "left" },
                        { label: "Center", value: "center" },
                        { label: "Right", value: "right" },
                    ],
                    defaultValue: { label: "Center", value: "center" },
                    isParent: true,
                },
                {
                    title: "Vertical Align",
                    type: "SELECT_BOX",
                    reduxKey: "legendVerticalAlign",
                    options: [
                        { label: "Top", value: "top" },
                        { label: "Middle", value: "middle" },
                        { label: "Bottom", value: "bottom" },
                    ],
                    defaultValue: { label: "Bottom", value: "top" },
                    isParent: true,
                },
                {
                    title: "Layout",
                    type: "SELECT_BOX",
                    reduxKey: "legendLayout",
                    options: [
                        { label: "Horizontal", value: "horizontal" },
                        { label: "Vertical", value: "vertical" },
                    ],
                    defaultValue: { label: "Horizontal", value: "horizontal" },
                    isParent: true,
                },
            ],
        },
    ];
};

export { getDataFieldsstackedimage, getCustomizationFieldStackedimage };
